import { DialogLayout } from "@/subframe/layouts/DialogLayout";
import { IconWithBackground } from "@/subframe/components/IconWithBackground";
import { Alert } from "@/subframe/components/Alert";
interface SwitchToAHumanAgentPopupProps {
  open: boolean;
  setIsSwitchToHumanAgentPopupOpen: React.Dispatch<
    React.SetStateAction<boolean>
  >;
}
function SwitchToHumanAgent({
  open,
  setIsSwitchToHumanAgentPopupOpen,
}: SwitchToAHumanAgentPopupProps) {
  return (
    <DialogLayout open={open} onOpenChange={setIsSwitchToHumanAgentPopupOpen}>
      <div className="flex w-96 flex-col items-start gap-6 px-6 py-6">
        <div className="flex w-full flex-col items-center gap-6">
          <div className="flex w-full flex-col items-end gap-6">
            <div className="flex w-full flex-col items-center gap-4 px-1 py-1">
              <IconWithBackground
                variant="warning"
                size="large"
                icon="FeatherToggleLeft"
              />
            </div>
            <span className="text-heading-2 font-heading-2 text-default-font text-center">
              Your client&#39;s message is now handed over to you.
            </span>
            <Alert
              variant="warning"
              title="AI Assistant"
              description="Disabled: Automation tool connections (Zapier, Make, etc.) disconnected."
            />
          </div>
        </div>
      </div>
    </DialogLayout>
  );
}

export default SwitchToHumanAgent;
